import { MHLogoDots } from '@/src/components/mh';

interface TypingDotsLogoProps {
  className?: string;
}

export function TypingDotsLogo({ className }: TypingDotsLogoProps) {
  return <MHLogoDots className={className} aria-label="mindhunters" />;
}
